import React from 'react';

interface FormGenericContainerPropsBase {
  footer?: () => React.ReactNode;
  bodyClassName?: string;
  footerClassName?: string;
}

type FormGenericContainerProps = React.HTMLAttributes<HTMLElement> & FormGenericContainerPropsBase;

// FIXME: move to bubbleform.tsx later
export function FormGenericContainer(props: FormGenericContainerProps) {
  const {
    footer,
    className: propClasses,
    bodyClassName: propBodyClasses,
    footerClassName: propFooterClasses,
    children,
    ...rest
  } = props;

  const classes = ['form-page-container'];
  if (propClasses) classes.push(propClasses);

  const bodyClasses = ['p-8'];
  if (footer) bodyClasses.push('pb-2');
  if (propBodyClasses) bodyClasses.push(propBodyClasses);

  const footerClasses = ['flex items-start sticky bottom-0 z-20 p-8 pt-4 form-blur'];
  if (propFooterClasses) footerClasses.push(propFooterClasses);

  return (
    <div {...rest} className={classes.join(' ')}>
      <div className={bodyClasses.join(' ')}>{children}</div>
      {footer && <div className={footerClasses.join(' ')}>{footer()}</div>}
    </div>
  );
}
